<template>
  <div class="dropdown" ref="dropdownRef" @click="toggleMenu">
    <slot />
    <div class="dropdown-body" v-show="isOpen">
      <slot name="body" />
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeUnmount } from 'vue';

const props = defineProps({
  noToggle: { type: Boolean, default: false }
});

const isOpen = ref(false);
const dropdownRef = ref(null);

function toggleMenu(event) {
  event.stopPropagation();
  if (props.noToggle && isOpen.value) return;

  isOpen.value = !isOpen.value;

  if (isOpen.value) {
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
  } else {
    clear();
  }
}

function handleClickOutside(event) {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    closeMenu();
  }
}

function closeMenu() {
  isOpen.value = false;
  clear();
}

function handleEscape(event) {
  if (event.key === 'Escape') closeMenu();
}

function clear() {
  document.removeEventListener('click', handleClickOutside);
  document.removeEventListener('keydown', handleEscape);
}

onBeforeUnmount(clear);
</script>

<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.dropdown-body {
  position: absolute;
  top: 100%;
  z-index: 1000;
  backface-visibility: hidden;
  transform: translateZ(0);
}
</style>
